import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { FilterService } from '@/coreDomainsModule/services/filterService';
import { OrderControlRepository } from '@/coreInfrastructureModule/Repositories/OrderControlRepository';
import { FilterContentItem } from '@/corePagesModule/filterModal/filterModal';

/**
 * 承認依頼情報を持っている集計ID一覧を取得するUseCase
 * IDの配列(string[])を返す
 */
export class GetApprovedRequestOrderIdsUseCase {
  /**
   * 承認依頼情報を持つ集計ID情報を取得する
   * @param repository - 取引情報の永続化の責務を負うクラス
   * @param filterItems - フィルタリングに使用する項目
   * @returns IDの配列(string[])
   */
  public Execute = async (
    repository: OrderControlRepository,
    filterItems: FilterContentItem[]
  ): Promise<INetworkResult<string[], Error>> => {
    try {
      const [filterItem, filterInfoItem] = FilterService.convertFilterObjectWithInfo(filterItems);
      const result = await repository.getApprovedRequestOrderIds(filterItem, filterInfoItem);

      switch (result.status.type) {
        case 'success':
          break;
        case 'error':
          throw result.status.error;
        default:
          throw new Error('Invalid status');
      }

      return {
        status: { type: 'success', data: result.status.data.aggregateBusinessIds },
      };
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('取得に失敗しました'),
        },
      };
    }
  };
}
